import { render, staticRenderFns } from "./RevContent.vue?vue&type=template&id=42123c83"
import script from "./RevContent.vue?vue&type=script&lang=js"
export * from "./RevContent.vue?vue&type=script&lang=js"
import style0 from "./RevContent.vue?vue&type=style&index=0&id=42123c83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports